import { IonButton, IonCol, IonRow } from '@ionic/react';
import { Field, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import LabeledInput from '../../../mdc/LabeledInput';
import Form from '../../common/Form';
import styled from 'styled-components';
import PhoneInput from 'react-phone-number-input';
import { RecaptchaVerifier } from 'firebase/auth';
import useRecaptcha from '../../../hooks/useRecaptcha';

const StyledForm = styled(Form)`
  padding: 0 24px;
`;
const ButtonRow = styled(IonRow)`
  margin-top: 8px;
  width: 100%;
`;
const StyledPhoneInput = styled(PhoneInput)`
  margin-left: -40px;
`;

interface PhoneNumberFormProps {
  phoneNumber: string;
  onSubmit: (
    values: { phoneNumber: string },
    recpatcha: RecaptchaVerifier
  ) => Promise<void>;
}

const RECAPTCHA_ID = 'recaptcha-container';

const PhoneNumberForm: React.FC<PhoneNumberFormProps> = ({
  phoneNumber,
  onSubmit,
}) => {
  const recaptcha = useRecaptcha(RECAPTCHA_ID, {
    size: 'invisible',
    callback: () => console.log('reCAPTCHA verified'),
    expiredCallback: () => console.log('EXPIRED'),
  });

  return (
    <Formik
      initialValues={{ phoneNumber }}
      onSubmit={(values) => onSubmit(values, recaptcha.current!)}
      validateOnMount
      validationSchema={Yup.object({
        phoneNumer: Yup.string().length(10),
      })}
    >
      {({
        handleSubmit,
        values,
        isValid,
        touched,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        submitForm,
      }) => (
        <StyledForm onSubmit={handleSubmit}>
          <IonRow>
            <IonCol>
              <StyledPhoneInput
                name="phoneNumber"
                type="tel"
                inputMode="tel"
                defaultCountry="US"
                label="Phone number"
                inputComponent={LabeledInput}
                value={values.phoneNumber}
                onChange={(phoneNumber) => {
                  const value = phoneNumber || '';
                  setFieldValue('phoneNumber', value);
                  if (!touched.phoneNumber) {
                    setFieldTouched('phoneNumber', true);
                  }
                }}
              />
            </IonCol>
          </IonRow>
          <ButtonRow>
            <IonCol>
              <IonButton
                type="submit"
                disabled={!isValid || isSubmitting}
                expand="block"
              >
                Save
              </IonButton>
            </IonCol>
          </ButtonRow>
          {phoneNumber && (
            <ButtonRow>
              <IonCol>
                <IonButton
                  fill="clear"
                  type="button"
                  color="danger"
                  disabled={isSubmitting}
                  expand="block"
                  onClick={async () => {
                    setFieldValue('phoneNumber', '');
                    setFieldTouched('phoneNumber', true);

                    try {
                      await submitForm();
                    } catch (e) {
                      // Error should be handled in the submitForm function, just need to restore the form state
                      setFieldValue('phoneNumber', phoneNumber);
                    }
                  }}
                >
                  Remove Phone Number
                </IonButton>
              </IonCol>
            </ButtonRow>
          )}
          <div id={RECAPTCHA_ID} />
        </StyledForm>
      )}
    </Formik>
  );
};

export default PhoneNumberForm;
